<div class="modal-header">
  <h4 class="modal-title header-5">
    Steps to Generate Test Scripts
  </h4>
 <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
        alt="Close"
      />
    </button>
</div>

<div class="modal-body">
  <span class="header-8">
    Steps to generate the Test Scripts automatically
  </span>
  <ol class="mt-3">
    <li>Go to the Chrome Web Store and download the Accello Web Recorder.</li>

    <li>
      Start the recording using the Accello Web Recorder extension.
      <a
        class="download-text general-text-10"
        (click)="downloadExtentioComponent()"
        >Click here to download</a
      >
    </li>
    <li>
      Once you stop the recording, click on the "Load Activities" button in the code
      view of the Chrome extension.
    </li>
    <li>The recorded steps will be populated in the code view.</li>
    <li>Click on "Save" to generate your Playwright scripts.</li>
  </ol>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end">
    <button
      class="btn-accello-secondary mx-2 close-btn"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button class="btn btn-accello-primary-light" (click)="loadRecordActivities()">
      <span> Start Now </span>
    </button>
  </div>
</div>
